import { useTranslation } from 'react-i18next';

import { BlueContainer } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';

interface PowerCardProps {
  title?: string;
  description?: string;
  showPower?: boolean;
}

export function PowerCard({ title, description, showPower }: PowerCardProps) {
  const { t } = useTranslation();

  return (
    <BlueContainer
      withShadow
      className={cn('mb-4 flex flex-col gap-4', !showPower && 'min-h-[150px]')}
    >
      <div className="flex w-[calc(100%-112px)] items-center gap-3 sm:w-[calc(100%-152px)]">
        <span className="text-3xl">🦸</span>
        <h4 className="wrap-break-word text-xl font-semibold text-foreground">
          {t('user_profile.super_power')}
        </h4>
      </div>

      {title && (
        <span className="w-fit max-w-[calc(100%-104px)] truncate rounded-[13px] bg-background px-3.5 py-2 text-base font-semibold leading-none text-foreground sm:max-w-[calc(100%-144px)]">
          {title}
        </span>
      )}
      {description && <p className="mt-2 text-sm text-foreground">{description}</p>}
    </BlueContainer>
  );
}
